export default __webpack_public_path__ + "static/media/neck_base.1cdf996b.webp";